import cn from "classnames"

import { Card, Flex, Link } from "@/atoms"
import { getTicketingSystemFromUrl } from "@/domain/ticketing"
import { IconText } from "@/molecules/IconText"
import { TICKETING_LOGOS } from "@/molecules/TicketingSystemLogo"

import styles from "./TicketCard.module.scss"

export interface TicketCardProps {
  ticketKey: string
  ticketUrl?: string
  type?: "primary" | "secondary"
  aside?: React.ReactNode
}

export const TicketCard = ({
  ticketKey,
  ticketUrl,
  type = "primary",
  aside
}: TicketCardProps) => (
  <Link
    href={ticketUrl}
    target="_blank"
    className={cn(styles.link, !ticketUrl && styles.linkEmpty)}
  >
    <Card
      className={
        type === "secondary" ? styles.cardSecondary : styles.cardPrimary
      }
    >
      <Flex align="center" justify="space-between" gap={8}>
        <Flex flex={1} align="center">
          <IconText
            Icon={TICKETING_LOGOS[getTicketingSystemFromUrl(ticketUrl)]}
            classes={{ container: styles.jiraInfo, icon: styles.icon }}
          >
            <span className={styles.text}>{ticketKey}</span>
          </IconText>
        </Flex>
        {aside}
      </Flex>
    </Card>
  </Link>
)
